import { MaskLines } from "./motion";
import { GlassCard } from "./Glass";

const chapters = [
  {
    num: "01",
    title: "Explorador privado",
    body:
      "Tu propio explorador blockchain donde solo ves las operaciones relacionadas con tu cuenta. Transparencia total, sin exponer tu actividad.",
  },
  {
    num: "02",
    title: "KYC para todos",
    body:
      "Cada usuario pasa por un proceso de verificación de identidad. Una red privada de participantes verificados, sin anónimos.",
  },
  {
    num: "03",
    title: "Seguridad por diseño",
    body:
      "Medidas de seguridad en cada capa. Sabes siempre a quién envías y cada operación queda registrada de forma verificable en la FSC.",
  },
];

export const Explorer = () => {
  return (
    <section
      id="seguridad"
      data-testid="seguridad-section"
      className="flex min-h-screen items-center bg-canvas px-6 pb-24 pt-28 text-ink md:px-12"
    >
      <div className="mx-auto w-full max-w-6xl">
        <h2 className="max-w-3xl font-display text-4xl font-light leading-none tracking-tight text-ink md:text-6xl">
          <MaskLines lines={["Una red privada,", "verificable y segura."]} />
        </h2>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
          {chapters.map((c, i) => (
            <GlassCard
              key={c.num}
              testId={`chapter-${c.num}`}
              delay={i * 0.08}
              className="p-8"
            >
              <span className="font-accent text-5xl font-light text-gold md:text-6xl">
                {c.num}
              </span>
              <h3 className="mt-6 font-display text-2xl text-ink md:text-3xl">
                {c.title}
              </h3>
              <p className="mt-3 font-body text-base leading-relaxed text-ink-soft">
                {c.body}
              </p>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
};

